import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    NativeSelect
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import EditIcon from '@material-ui/icons/Edit';
import Axios from 'axios';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import * as yup from "yup";

const validationSchema = yup.object({
  value: yup.number().test(
    "maxDigits",
    " value field must be 10 digits or less",
    (value) => String(value).length <= 10
  )
  .required(" value is required!"),

});
export default function Edit(props){
    const [open, setOpen]                = useState(false);
    const [loading,setLoading]           = useState(false);
    const {setClaims,client_case_id,row} = props;
    const {type}                         = props;

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const onSubmit = async (values) => {
      setLoading(true);
      const formObj ={
          client_case_id: client_case_id ? client_case_id : null,
          party: values.party ?? 'me',
          description:values.description,
          method:values.method,
          value:values.value,
          other_liens:values.other_liens,
          client_sp:values.client_sp,
          spouse_sp:values.spouse_sp,
          to_client:values.to_client,
          cost:values.cost,
          notes:values.notes,
          type: type
      };

      const response = await Axios
        .put("api/estate/equitable/claim/"+row.id, formObj)
        .catch((err) => {
          if (err && err.response) console.log("Error", err);
        });
  
      if (response) {
        setOpen(false);
        setClaims(response.data.data);
        setTimeout(()=>{
          setLoading(false);
        }, 1500);
      }
    };

    const formik = useFormik({
      initialValues: {
        party:row.party,
        description:row.description,
        method:row.method,
        value:row.value,
        other_liens:row.other_liens,
        client_sp:row.client_sp,
        spouse_sp:row.spouse_sp,
        to_client:row.to_client,
        cost:row.cost,
        notes:row.notes,
      },
      validateOnBlur: true,
      onSubmit,
      validationSchema:validationSchema
    });

    return (
        <div>
          <div className="card-toolbar"> 
                <IconButton aria-label="update" onClick={handleClickOpen}>
                    <EditIcon />
                </IconButton> 
            </div>
          <Dialog
            fullWidth={true}
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{type === 1 ? 'Equitable Claims in Favor of the Marital/Community Estate' : "Equitable Claim in Favor of Either Party's Separate Estate"}</DialogTitle>
            <DialogContent>
            <DialogContentText>
                <div className="login-form login-signin" id="kt_login_signin_form">
                <form
                     onSubmit={formik.handleSubmit}
                    className="form fv-plugins-bootstrap fv-plugins-framework"
                  >
                    <div className="form-group fv-plugins-icon-container">
                      <FormControl variant="outlined" style={{width: "100%"}}>
                        <Form.Label>{type === 1 ? 'Against whose separate estate does the marital/community estate have a claim?' : 'Whose separate estate has a claim against the martial/community estate?'}</Form.Label>
                        <InputLabel id="demo-simple-select-outlined-label"></InputLabel>
                        <NativeSelect
                            className={`form-control form-control-solid h-auto py-5 px-6 `}
                            inputProps={{
                              name: 'party',
                            }}
                           defaultValue={formik.values.party}
                           onChange={formik.handleChange}
                           onblur={formik.handleBlur}
                          >
                          <option value="me" selected>Me</option>
                          <option value="spouse">My Spouse</option>
                          </NativeSelect>
                      </FormControl>
                    </div>
    
                    <div className="form-group fv-plugins-icon-container">
                      <Form.Label>Describe the Claim</Form.Label>
                      <input
                        type="text"
                        className={`form-control form-control-solid h-auto py-5 px-6 `}
                        name="description"
                        onChange={formik.handleChange}
                        onblur={formik.handleBlur}
                        value={formik.values.description}
                      />
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                        {formik.errors.description ? formik.errors.description : ""}
                        </div>
                      </div>
                    </div>

                    <div className="form-group fv-plugins-icon-container">
                      <Form.Label>What is the amount of the claim? </Form.Label>
                      <input
                        type="number"
                        name="value"
                        className={`form-control form-control-solid h-auto py-5 px-6 `}
                        onChange={formik.handleChange}
                        onblur={formik.handleBlur}
                        value={formik.values.value}
                      />
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                        {formik.errors.value ? formik.errors.value : ""}
                        </div>
                      </div>
                    </div>

                    <div className="form-group fv-plugins-icon-container">
                      <Form.Label>How did you arrive at the amount of the claim?  </Form.Label>
                      <input
                        type="text"
                        className={`form-control form-control-solid h-auto py-5 px-6 `}
                        name="method"
                        onChange={formik.handleChange}
                        onblur={formik.handleBlur}
                        value={formik.values.method}
                      />
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                        {formik.errors.method ? formik.errors.method : ""}
                        </div>
                      </div>
                    </div>

                    <div className="form-group fv-plugins-icon-container">
                      <Form.Label>Do you have anything to add to allow your lawyer to better understand this claim? </Form.Label>
                      <input
                        type="text"
                        className={`form-control form-control-solid h-auto py-5 px-6 `}
                        name="notes"
                        onChange={formik.handleChange}
                        onblur={formik.handleBlur}
                        value={formik.values.notes}
                      />
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                        {formik.errors.notes ? formik.errors.methnotesod : ""}
                        </div>
                      </div>
                    </div>
                    
                    <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                      <button
                        id="kt_login_signin_submit"
                        type="submit"
                        disabled={loading}
                        className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
                      >
                        <span>Submit</span>
                        {loading && (
                          <span className="ml-3 spinner spinner-white"></span>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </div>
      );
}